import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  TextField
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';


const useStyles = makeStyles((theme) => ({
  root: {
    color: 'white'
  },
  buttonSuccess: {
    width: '10%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    color:'white',
    marginTop: 7,
    marginLeft: 180,
    backgroundColor: '#1D3343',
    '&:hover': {
      backgroundColor: 'white'
    },
  },
  content: {
    minHeight: 130,
    minWidth: 530
  }
}));

function Follow({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [sendNote, setSendNote] = useState('');
  const [notePopUp, setNotePopup] = useState(false);
  const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
  const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
  const [Required, setRequired] = React.useState(false);
  const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
  const today = new Date();
  const YazdirMerkezeGonderData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo))

 
  const confirmOkey = (msg) => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: t('Tamam'),
          onClick: () => { }
        }
      ]
    });
  };

  const sendNoteYes = (Note) => {
    if(Note.length <= 0)
    {
      setRequired(true);
    }
    else{
    const data = {
      ReceiptNo,
      Note,
      WatchListId: YazdirMerkezeGonderData[0].WatchListId,
      EmployeeId: parseInt(SessionUser.TechnicianId),
      ServiceShop:YazdirMerkezeGonderData[0].ServiceShop,
      ServiceShopId:YazdirMerkezeGonderData[0].ServiceShopId,
      MobileStatusId:YazdirMerkezeGonderData[0].MobileStatusId,
      Status:YazdirMerkezeGonderData[0].Status,
      WorkCaseId:YazdirMerkezeGonderData[0].WorkCaseId,
      CallDate:YazdirMerkezeGonderData[0].OpenDate,
      ContactName:YazdirMerkezeGonderData[0].ContactName,
      ConsumerId:YazdirMerkezeGonderData[0].ConsumerId,
      FollowDate:today,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);
    axios.post('/SetWatchList', data, config)
      .then((response) => {
        setUyariAciklamaNote(t('lblNoteMessage'));
        setUyariTipCiktiNote('success'); 
        setUyariCiktiNote(true);
        setNotePopup(false);
        setLoading(false);
      }).catch((error) => {
        confirmOkey(error.message);
        setNotePopup(false);
        setLoading(false);
      });
    }
  };
  const uyariKapatCiktiNote = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiNote(false);
  };

  return (
    <Card className={clsx(classes.root, className)}>
  
        {uyariCiktiNote ? (
        <Alert
          onClose={uyariKapatCiktiNote}
          open={uyariCiktiNote}
          message={uyariAciklamaNote || ''}
          variant={uyariTipCiktiNote}
        />
      ) : (
        <div />
      )} 
      <Divider />
      <CardContent className={classes.content}>
        {
          loading
            ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            )
            : <div />
        }
        <div>
          <div>
          <TextField 
            size="small"
            id="Note"
            error={sendNote.length > 0 ? false : Required}
            required
            autoComplete="no"
            value={sendNote ? sendNote : ''}
            onChange={(event) => setSendNote(event.target.value)}
            fullWidth
            label={t('lblwriteNote')}
            variant="outlined"
          />
            <Button 
            className={classes.buttonSuccess}
            onClick={() => {
              sendNoteYes(sendNote);
              
            }}
            color="primary"
            variant="container"
            disabled={YazdirMerkezeGonderData[0].Follow === 1 ? true : false}
          >
            {t('lblSave')}
            
          </Button>
          </div>
        </div>
      </CardContent>
    </Card>

  );
}

Follow.propTypes = {
  className: PropTypes.string
};

export default connect((state) => ({ tasks: state.tasks1 }))(Follow);
